import React, { FunctionComponent } from 'react'
import { Field, Form } from 'react-final-form'
import { useIntl } from 'react-intl'
import { GestureResponderEvent, ScrollView, View } from 'react-native'

import styled from 'styled-components/native'

import { BodyText } from '../../../atoms/bodyText/BodyText'
import { Button, ButtonTypes } from '../../../atoms/button/Button'
import { Divider } from '../../../atoms/divider/Divider'
import { IS_WEB } from '../../../constants'
import { ToggleSwitchRFF } from '../../../molecules/toggleSwitch/ToggleSwitch'
import { BodyTextSize } from '../../../styles/typeStyles'
import { tID } from '../../../utils/utils'

const ButtonContainer = styled.View({
  padding: '20px 0px 8px 0px',
})

const RowContainer = styled.View({
  paddingBottom: '15px',
})

const ListContainer = styled(ScrollView)({
  maxHeight: IS_WEB ? '300px' : 'initial',
})

/**
 * Common template rendering the forms for the persist store keys
 */
export const PersistFormTemplate: FunctionComponent<PersistFormTemplateProps> = ({
  onSubmit,
  onClearAll,
  values,
  testID,
}) => {
  const { formatMessage } = useIntl()
  const initialValues = Object.assign({}, ...Object.keys(values).map((key: string) => ({ [key]: false })))
  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <View testID={tID(testID)}>
          <ListContainer>
            {Object.entries(values)
              .sort((a, b) => a[0].localeCompare(b[0]))
              .map(([key, { label, currentValue }]) => {
                return (
                  <>
                    <RowContainer key={`${key}`}>
                      <Field key={key} component={ToggleSwitchRFF} label={label} name={`${key}`} />

                      <BodyText
                        text={formatMessage({
                          defaultMessage: 'Current Value:',
                          description: 'Label for current value in persist store form',
                        })}
                        size={BodyTextSize.SMALL}
                      />
                      <BodyText text={currentValue} size={BodyTextSize.SMALL} />
                    </RowContainer>
                    <Divider />
                  </>
                )
              })}
          </ListContainer>
          <ButtonContainer>
            <Button
              title={formatMessage({
                defaultMessage: 'Clear Selected Persistent Store Keys',
                description: 'Button to clear selected keys in persist store',
              })}
              onPress={handleSubmit}
              buttonType={ButtonTypes.DEV}
            />
          </ButtonContainer>
          <ButtonContainer>
            <Button
              title={formatMessage({
                defaultMessage: 'Clear All keys',
                description: 'Button to clear all keys in persist store',
              })}
              onPress={onClearAll}
              buttonType={ButtonTypes.DEV}
              testID={tID('clearAllKeys')}
            />
          </ButtonContainer>
        </View>
      )}
    />
  )
}

type PersistFormTemplateProps = {
  onSubmit: (values: Dict) => void
  onClearAll: (event: GestureResponderEvent) => void
  values: {
    [key: string]: {
      label: string
      currentValue: string
    }
  }
  testID?: string
}
